<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'Visitors'}">
              <h4 class="ms-2">
                {{label.pages.visitors}}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
            </h4>
          </b-col>
          <b-col cols="2" class="text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <DxDataGrid
              :show-row-lines="true"
              :show-column-lines="true"
              :show-borders="true"
              :row-alternation-enabled="true"
              :rtl-enabled="true"
              :data-source="data"
              :columns="fields"
              :remote-operations="true"
              :column-auto-width="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              column-resizing-mode="widget"
              :hover-state-enabled="true"
              :noDataText="checkData"
              @toolbar-preparing="onToolbarPreparing($event)"
              key-expr="id"
              class="ps_Table"
              :height="dataGridHeight"
          >
            <DxSearchPanel
                :visible="true"
                :width="240"
                :placeholder="label.pages.search"
            />
            <DxColumnChooser
                :enabled="true"
                mode="dragAndDrop"
            />
            <DxExport
                :enabled="true"
            />
            <template #btnRGroup>
              <div></div>
            </template>
            <template #btnGroup>
              <div>
                <b-row class="ms-2">
                  <b-col cols="auto" class="px-0">
                    <b-button
                        variant="ps-secondary"
                        class="py-1 pb-2"
                        size="sm"
                        v-b-tooltip.noninteractive.hover
                        :title="label.buttons.reload"
                        @click="reloadData"
                    >
                      <b-icon icon="arrow-repeat" scale="1.5" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template #radif="{data}">
              <div>
                {{ data.rowIndex + 1 }}
              </div>
            </template>
            <template #actions="{data}">
              <b-row class="justify-content-center">
                <b-col cols="auto" class="px-0">
                  <button
                      @click="delConfirm(data)"
                      :id="'deleteBtnTlp-' + data.data.id"
                  >
                    <b-icon icon="x-square-fill" scale="1.1" variant="ps-delete-icon"></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'deleteBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.delete }}
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <DxSorting mode="multiple"/>
            <DxLoadPanel :enabled="true"/>
            <DxScrolling mode="virtual"/>
          </DxDataGrid>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!-- Delete Confirm Modal -->
    <b-modal
        dir="rtl"
        v-model="delModal"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row>
          <p class="fs10 text-center lh1 mb-0">
            {{ label.captions.deleteConfirm}}
            <br/>
            <strong>« {{ delTitle }} »</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="delModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-danger"
                size="sm"
                class="mx-1"
                @click="deleteNewsletter"
            >
            {{label.buttons.deleteConfirm}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {dataGridMixin} from '@/components/dataGrid/dataGridMixin'
import label from "@/plugins/StaticLabels.js";

export default {
  name: 'NewsLetter',
  mixins: [dataGridMixin],
  data() {
    return {
      label,
      delId: null,
      delTitle: null,
      delModal: false,
      fields: [
        {
          cellTemplate: 'radif',
          caption: 'ردیف',
          allowSorting: false,
          allowFiltering: false,
          width: '80px',
          cssClass: 'text-center align-middle fs10'
        },
        {
          cellTemplate: 'actions',
          caption: 'عملیات',
          allowSorting: false,
          allowFiltering: false,
          width: '110',
          alignment: 'center'
        },
        {
          dataField: 'input',
          caption: 'راه ارتباطی',
          dataType: 'string',
          cssClass: 'text-center align-middle fw2'
        },
        {
          dataField: 'createdLocal',
          caption: 'تاریخ ثبت',
          allowSorting: false,
          allowFiltering: false,
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'isSeen',
          caption: 'وضعیت (خوانده شده)',
          dataType: 'boolean',
          alignment: 'center'
        },
      ],
    }
  },
  watch: {
    postCheck() {
      this.reloadData();
    },
  },
  computed: {
    ...mapGetters({
      data: 'baseX/newsletters',
      postCheck: 'postCheck',
    }),
  },
  methods: {
    delConfirm(item) {
      this.delId = item.data.id;
      this.delTitle = item.data.input;
      this.delModal = true;
    },
    deleteNewsletter() {
      this.$store.dispatch('baseX/deleteNewsletter', "?ids=" + this.delId);
      this.delModal = false;
    },
    reloadData() {
      this.$store.dispatch('baseX/getNewsletters');
    },
  },
  mounted() {
    this.reloadData();
  },
}
</script>
